import cn from 'classnames'
import React from 'react'
import WithGlobalNav from '@groovehq/internal-design-system/lib/components/GlobalNav/WithGlobalNav/WithGlobalNav'

import AppNotices from 'components/AppNotices'
import GlobalNav from 'components/App/DesktopView/Layout/GlobalNav'
import Title from 'components/App/Title'
import Tracking from 'components/App/Tracking'
import { BusinessHoursNotice, ControlBar } from 'ducks/reports/controls'
import { Grid } from 'util/ui'
import SUI from 'shared/components/ui/SUI'

import ReportsSidebar from '../ReportsSidebar'
import styles from './styles.less'

export default class ReportsLayout extends React.Component {
  componentDidMount() {
    if (!this.props.layoutMounted) this.props.onComponentDidMount()
  }

  componentDidUpdate() {
    if (!this.props.layoutMounted) this.props.onComponentDidUpdate()
  }

  render() {
    const { children, layoutMounted, isLeftSidebarCollapsed } = this.props
    return (
      <>
        <Title />
        <Tracking />
        <WithGlobalNav
          globalNav={<GlobalNav active="Reporting" />}
          topContent={<AppNotices />}
          leftSidebar={<ReportsSidebar />}
          isLeftSidebarCollapsed={isLeftSidebarCollapsed}
        >
          <SUI transparent={false}>
            <div className={styles.app}>
              <div className={cn('AppMain', 'ReportsApp', styles.content)}>
                <ControlBar prerenderDatePicker={layoutMounted} />
                {layoutMounted && (
                  <div className={styles.scrollContainer}>
                    <div className={styles.widthContainer}>
                      <Grid columns={1} stackable padded>
                        <Grid.Column width={16}>
                          <BusinessHoursNotice />
                          <React.Fragment>{children}</React.Fragment>
                        </Grid.Column>
                      </Grid>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </SUI>
        </WithGlobalNav>
      </>
    )
  }
}
